<template>
    <v-card class="detail-card" :color="cardColor" height="auto">
        <v-card-title>
            <span class="headline">
                {{ title }}
            </span>
        </v-card-title>
        <v-card-text>
            <slot />
        </v-card-text>

        <v-card-actions>
            <v-btn v-if="!hideDelete" color="quinary" text :disabled="readonly" @click="deleteItem">Delete</v-btn>
        </v-card-actions>
    </v-card>
</template>
<script>
    export default {
        props: [
            'cardColor',
            'hideDelete',
            'title',
            'readonly'
        ],
        methods: {
            deleteItem() {
                this.$emit('delete');
            }
        },
    };
</script>
<style>
    .detail-card {
        margin: 10px 10px 0px 0px;
        width: 350px;
    }
</style>
